// TestMode.tsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserMerchants,
  selectMerchants,
  selectMerchantLoading,
  selectMerchantError,
  Merchant,
} from "../../../redux/merchantSlice";
import type { AppDispatch, RootState } from "../../../redux/store";

export default function TestMode() {
  const dispatch = useDispatch<AppDispatch>();

  // ─── 1. Get the real authenticated user from Redux ───
  const user = useSelector((state: RootState) => state.auth.user);
  
  const merchants = useSelector(selectMerchants);
  const loading = useSelector(selectMerchantLoading);
  const error = useSelector(selectMerchantError);

  useEffect(() => {
    // ─── 2. Use the actual userId if it exists ───
    if (user?.userId) {
      dispatch(fetchUserMerchants(user.userId));
    }
  }, [dispatch, user?.userId]);

  if (loading) return <div style={{ padding: 20 }}>Loading merchants…</div>;
  if (error) return <div style={{ padding: 20, color: "red" }}>{error}</div>;
  if (!user) return <div style={{ padding: 20 }}>Please sign in to view keys.</div>;

  return (
    <div style={{ padding: 20, fontFamily: "'Libre Franklin', sans-serif" }}>
      <h2 style={{ marginBottom: 16 }}>Test Mode API Keys</h2>

      {merchants.length === 0 && <p>No merchants found.</p>}

      {merchants.map((m: Merchant) => (
        <div key={m.merchantId} style={{ marginBottom: 24, border: "1px solid #D4CFC8", padding: 16, borderRadius: 8 }}>
          <h3 style={{ marginBottom: 4 }}>{m.businessName}</h3>
          <p style={{ fontSize: 12, color: "#666", marginBottom: 12 }}>ID: {m.merchantId}</p>

          {m.keys ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <div>
                <strong style={{ fontSize: 13 }}>Test Publishable Key:</strong><br/>
                <code style={{ background: "#eee", padding: "2px 6px" }}>{m.keys.pk_test || "Not Generated"}</code>
              </div>
              
              <div>
                <strong style={{ fontSize: 13 }}>Test Secret Key:</strong><br/>
                {/* Note: Backend only stores the hash for security. Plaintext sk_test is only available at creation */}
                <code style={{ background: "#eee", padding: "2px 6px", color: "#9B958D" }}>
                  {m.keys.sk_test_hash ? "•••••••• (Hashed)" : "Not Generated"}
                </code>
              </div>

              <div style={{ marginTop: 8, fontSize: 11, color: "#9B958D", textTransform: "uppercase" }}>
                Mode: {m.mode || "test"} | Live Enabled: {m.liveEnabled ? "Yes" : "No"}
              </div>
            </div>
          ) : (
            <div style={{ color: "#C8303A" }}>No keys generated for this organization.</div>
          )}
        </div>
      ))}
    </div>
  );
}
